if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          mobileThumbnails: document.querySelector('[id^="MobileThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 1024px)');
        
        if (this.elements.mobileThumbnails) {
          const viewer = this.elements.viewer;
          const slider = viewer.querySelector('[id^="Slider-Gallery"]');
          this.elements.mobileThumbnails.querySelectorAll('.mobileThumbnail--button').forEach((element) => {
            const variantOrder = element.dataset.variantOrder || 0;
            const mediaId = element.dataset.mediaId;
            if (!slider || !mediaId) return;
            element.addEventListener('click', function () {
              const media = viewer.querySelectorAll(`[data-media-id="${mediaId}"]`)[variantOrder];
              if (!media) return;
              slider.scrollLeft = media.offsetLeft;
            })
          });
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelectorAll(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia.forEach((element) => {
          element.classList.add('is-active');
        });

        if (prepend) {
          // activeMedia.forEach((el) => {
          //   activeMedia[0].parentElement.prepend(el);
          // })

          // if (this.elements.thumbnails) {
          //   const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          //   activeThumbnail.parentElement.prepend(activeThumbnail);
          // }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          // if (this.elements.thumbnails) {
          //   activeMedia[0].parentElement.scrollTo({ left: activeMedia[0].offsetLeft });
          // }

          if(window.innerWidth < 1024) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }

          if (activeMedia[0] && !this.elements.thumbnails || activeMedia[0] && this.dataset.desktopLayout === 'stacked') {
            activeMedia[0].scrollIntoView({ behavior: 'smooth' });
          }
        });


        activeMedia.forEach((el) => {
          this.playActiveMedia(el);
        })
        
        if (this.elements.mobileThumbnails) {
          this.elements.mobileThumbnails.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          this.elements.mobileThumbnails.querySelectorAll(`[data-media-id="${mediaId}"]`).forEach((element) => {
            element.classList.add('is-active');
          });
          const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
          if (slider) {
            setTimeout(() => {
              slider.scrollLeft = 0;
            }, 100);
          }
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        // this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia(this);
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);

        const activeVideo = activeItem.querySelector('video');
        if (!activeVideo) return;

        activeVideo.muted = true;
        activeVideo.setAttribute('muted', '');
        activeVideo.setAttribute('playsinline', '');

        const playAttempt = activeVideo.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(() => {});
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
